<template lang="html">
  <section class="contenedor-perfil" :style="styles.backgroundWhite">

    <h2 class="ficha-title -big" :style="styles.colorBasic">{{$t('encuestas')}}</h2>

    <div class="encuestas-container">

      <div class="encuesta-el" :style="styles.bgbody" v-for="el in encuestas">
        <h2 class="titulo" :style="styles.colorBasic">{{el.titulo}}</h2>
        <arrow-link :text="$t('comenzar')" :external="true" :to="brand.dominioEncuesta+el.urlAcceso" :blank="true"></arrow-link>

        <h3  :style="styles.colorBasic" v-if="el.nombrePractica || el.nombreEstudiante">{{el.nombrePractica}} - {{el.nombreEstudiante}}</h3>
        <arrow-link v-if="el.idPractica" :text="$t('ver_practica')" :external="true" :to="$t('enlaces.ficha')+'/'+el.idPractica" :blank="true"></arrow-link>
      </div>

    </div>

  </section>
</template>

<script lang="js">
  
  import {mapGetters, mapActions} from 'vuex';

  import arrowlink  from '@/components/parts/icons/arrow-link';

    
  
    export default  {
      name: 'Encuestas',
      mounted(){
        setTimeout(e => {
            this.requestEncuestas().then( r =>{
              this.data = r;
            })
          },200)
      },
      data(){
        return{
          loading : false
        }
      },
      components : {
        'arrow-link' : arrowlink,
      },
      methods: {
        ...mapActions(['requestEncuestas'])
      },
      computed : {
        ...mapGetters({
          styles : 'getStyles',
          colors : 'basicColors',
          encuestas : 'getEncuestas',
          brand : 'getBrand'
        }),
      },
    }
  </script>


// WEBPACK FOOTER //
// src/components/views/encuestas.vue